import React, { ReactNode, Fragment } from 'react';
import { Divider } from '../../wag-react/core-components/divider';
import { Box, BoxProps } from '../../wag-react/next-components/box';
import { theme } from '../../wag-react/themes/base-theme';
import { Answer } from './components/Answer';
import { Comment } from './components/Comment';
import { UGCItem } from './components/UGCItem';

// Typed generically like this because other content type Answer records
// could potentially have different properties
export type UGCAnswer = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
};

// Typed generically like this because other content type Comment records
// could potentially have different properties
export type UGCComment = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
};
export type UGCItem = {
  answer?: UGCAnswer;
  comments: UGCComment[];
  datePosted: string;
  images?: string[];
  text: string;
  userLabel: string;
};
export type UGCBlockProps = {
  HeaderComponent: ReactNode;
  ugcItem: UGCItem;
} & BoxProps;
export const UGCBlock = ({
  HeaderComponent,
  ugcItem,
  ...rest
}: UGCBlockProps) => <Box border={[0, `1px solid ${theme.colors.whisper}`]} borderRadius={[0, '12px']} borderTop={0} {...rest} data-sentry-element="Box" data-sentry-component="UGCBlock" data-sentry-source-file="index.tsx">
    {/* Will render a story or a question */}
    <UGCItem HeaderComponent={HeaderComponent} {...ugcItem} data-sentry-element="UGCItem" data-sentry-source-file="index.tsx" />

    <Box px={[0, '20px']} pb="20px" data-sentry-element="Box" data-sentry-source-file="index.tsx">
      {/* Answer only available on Question-like records */}
      {ugcItem.answer && <Answer avatarUrl={ugcItem.answer.user.avatarUrl} dateLabel={ugcItem.answer.datePosted} expertTitle={ugcItem.answer.user.expertTitle} expertName={ugcItem.answer.user.fullName} numRecommendations={ugcItem.answer.voteCountForAnswerer} recommendedText="Dog owners recommended" text={ugcItem.answer.text} mt="60px" />}

      {/* Comments available on UGC like stories and questions */}
      {ugcItem.comments.map(({
      datePosted,
      text,
      user
    }, index) => <Fragment key={text}>
          {index > 0 && <Divider m={0} />}

          <Comment datePosted={datePosted} text={text} userLabel={user} />
        </Fragment>)}
    </Box>
  </Box>;